import { useEffect } from 'react';

import { PeriodResultKind, useResultsStore } from '@/entities/result';
import { useSessionStore } from '@/entities/session';

import { SeasonFinalModal } from './SeasonFinalModal';

/**
 * Показывает прощание игры, когда сервер отдал непоказанный итог Финала.
 *
 * Отдельный хост, а не ветка в `ResultModalHost`: слой `widgets` не может
 * импортировать `widgets`, поэтому composition живёт в `app` — там же,
 * где приветствие и подписка. Условия двух хостов взаимоисключающие
 * по `kind`, так что двух панелей на экране не бывает.
 *
 * Очередь итогов общая и живёт на сервере: закрытие отмечается тем же
 * `POST /results/seen`, после чего стор просит следующий итог. Порядок
 * («Финал раньше месячного розыгрыша») задаёт `RESULT_PRIORITY` бэкенда,
 * клиент про него не знает.
 */
export function SeasonFinalModalHost() {
  const pending = useResultsStore((state) => state.pending);
  const loadResults = useResultsStore((state) => state.load);
  const dismissResult = useResultsStore((state) => state.dismiss);

  const isNewUser = useSessionStore((state) => state.isNewUser);

  // Тот же запрос делает ResultModalHost. Дубля не будет: `load`
  // обёрнут в single-flight и уважает окно свежести
  useEffect(() => {
    void loadResults();
  }, [loadResults]);

  // Новичку — приветствие: две полноэкранные панели наложились бы
  if (isNewUser) return null;

  if (pending?.kind !== PeriodResultKind.SEASON_FINAL) return null;

  // Победителю «Победа!», всем остальным «Вот и всё». Условия допуска
  // к жеребьёвке (ГДД §11.3) решают, кто мог выиграть, а не кто увидит
  // конец кампании: «спасибо, что был её участником» адресовано игроку,
  // а не участнику выборки
  return (
    <SeasonFinalModal
      variant={pending.isWinner ? 'win' : 'over'}
      onClose={dismissResult}
    />
  );
}
